@if (workitem()) {
    <div class="p-3 wrap-container">
        <div class="font-xxl text-start">
            <span class="weight-medium">Task wrap up&nbsp;-&nbsp;</span>
            <span>{{ taskType() }}</span>
        </div>
        <div class="mt-3 d-flex align-items-start">
            <telxl-dropdown
                [colour]="
                    this.workitem().forceCompletionCodeSelection &&
                    this.menuItems().length &&
                    this.code() === ''
                        ? 'danger'
                        : 'light'
                "
                [menuItems]="menuItems()"
                [(selected)]="code"
                [outline]="hasCCOutline()"
                [placeholder]="
                    this.menuItems().length
                        ? 'Select a Completion Code'
                        : 'Completion Codes'
                "
                class="mw-100"
            />
        </div>
        <div class="d-flex w-100 justify-content-between mb-1">
            <div class="font-sm mt-3 text-start mb-2 ps-1">
                Any notes from this task?
            </div>
            <span [ngbTooltip]="isAiSummaryEnabledToolTip()">
                <telxl-button
                    colour="ai"
                    [style.cursor]="'pointer'"
                    [active]="summarising()"
                    [outline]="true"
                    (buttonClick)="getSummary()"
                    (shown)="summarising.set(true)"
                    (hidden)="summarising.set(false)"
                    [disabled]="!isAiSummaryEnabled()"
                >
                    <i class="fa-light fa-bolt-lightning"></i>
                    Append Summary
                </telxl-button>
            </span>
        </div>
        <div class="position-relative">
            <textarea
                placeholder="Notes.."
                class="w-100 notes-text px-3"
                rows="8"
                (keydown)="checkCharacterLimit($event)"
                [(ngModel)]="note"
                [class.character-length-warning]="
                    this.noteCharacterMaxLengthExceeded()
                "
                [class.summary-applied-border]="
                    !this.noteCharacterMaxLengthExceeded() && summary()
                "
            ></textarea>
            <div
                class="position-absolute character-limit-indicator px-3"
                [class.character-limit-indicator--red]="
                    this.noteCharacterMaxLengthExceeded()
                "
            >
                <span class="font-xs">
                    {{ this.noteCharacterLength() }} /
                    {{ maximumCharacterLimt }}
                </span>
            </div>
            @if (noSummaryMessage()) {
                <div class="mw-100">
                    <span class="font-xs text-danger">
                        {{ noSummaryMessage() }}
                    </span>
                </div>
            }
        </div>
        @if (wrapEnabled()) {
            <div class="font-sm weight-medium mt-3">
                <div class="mt-1">
                    <div class="d-flex flex-row align-items-center">
                        <div class="flex-grow-1">
                            <div>
                                <telxl-progressbar
                                    orientation="horizontal"
                                    [metric]="wrapCountdown().metric"
                                    defaultState="danger"
                                />
                            </div>
                        </div>
                        <div class="ms-2 flex-shrink-1 text-end">
                            {{ wrapCountdown().duration | formatDuration }}
                        </div>
                    </div>
                </div>
            </div>
        } @else {
            <div class="font-sm weight-medium mt-3">
                <div class="mt-1">
                    <div class="d-flex flex-row align-items-center">
                        <div class="flex-grow-1">
                            <div>Time spent in wrap-up for this task:</div>
                        </div>
                        <div class="ms-2 flex-shrink-1 text-end">
                            {{ wrapCountUp() | formatDuration }}
                        </div>
                    </div>
                </div>
            </div>
        }
        <div class="row mt-3">
            <div class="col-4"></div>
            <div class="col-4 pe-0">
                <div class="me-3">
                    @if (wrapEnabled()) {
                        <telxl-button
                            colour="light"
                            (buttonClick)="extend()"
                            [disabled]="!canExtend()"
                        >
                            Reset Wrap
                        </telxl-button>
                    }
                </div>
            </div>
            <div class="col-4 ps-0">
                <telxl-button
                    colour="dark"
                    [outline]="true"
                    [disabled]="
                        this.noteCharacterMaxLengthExceeded() || !canComplete()
                    "
                    (buttonClick)="complete()"
                >
                    Complete Task
                </telxl-button>
            </div>
        </div>
        @if (canExtend()) {
            <div class="row">
                <div class="col-4"></div>
                <div class="col-4 font-xs text-center wrapResets">
                    {{ resetDescription() }}
                </div>
            </div>
        }
    </div>
}
